export default __webpack_public_path__ + "static/media/NRExplorer.ec7b53f5.jpg";